<template>
  <div id="HLCM">
  <div id="cookie-warning" v-bind:class="{ show: show}">
    <div class="cookie-consent-head">
      <div class="content-asset">
        <h2>{{ localization.title }}</h2>
        <div class="info">
          <p>{{ localization.description }}</p>
        </div>
      </div>
    </div>
    <div class="cookie-consent-body">
    </div>
    <div class="cookie-consent-footer">
      <button class="button button-secondary" v-on:click="deny">
        {{ localization.buttons.deny }}
      </button>
      <button class="button button-blue" v-on:click="allow">
        {{ localization.buttons.allow }}
      </button>
    </div>
  </div>
  </div>
</template>

<script>

import axios from "axios";

const CONSENT_KEY = 'hl-consent-manager-consent-given';

export default {
  name: 'ConsentManager',
  data: function () {
    return {
      show: false,
      localization: {
        buttons: {}
      }
    }
  },
  methods: {
    allow: function (event) {
      window.localStorage.setItem(CONSENT_KEY, 'yes');
      localStorage.setItem('emos_privacy', '3');
      window.emos3.PRIV_MODE = '3';
      this.show = false;
    },
    deny: function (event) {
      window.localStorage.setItem(CONSENT_KEY, 'no');
      localStorage.setItem('emos_privacy', '2');
      window.emos3.PRIV_MODE = '2';
      this.show = false;
    },
    init: function(language) {
      axios.get(`../hlcm/${language}.json`).then(request => {
        this.localization = request.data;
      });

      const givenConsent = window.localStorage.getItem(CONSENT_KEY);
      if (!givenConsent) {
        this.show = true;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#HLCM {
  position: fixed;
  bottom: 0;
  margin: auto;
  font-size: 18px;
  z-index: 10000;
  pointer-events: none;
}

#cookie-warning {
  color: #666;
  font-size: 1.5rem;
  line-height: 14px;
  background: white;
  width: 100%;
  margin: auto;
  padding: 0 10%;
  pointer-events: auto;
  transform: translateY(100%);
  opacity: 0;
  transition: opacity 150ms, transform 400ms;
  box-sizing: border-box;
}

#cookie-warning.show {
  opacity: 1;
  transform: translateY(0%);
  transition: opacity 150ms, transform 400ms;
}

#cookie-warning h2 {
  color: #666;
  font-size: 24px;
}

#cookie-warning .cookie-consent-head {
  padding-top: 30px;
  text-align: center;
  display: flex;
  place-content: center;
}

#cookie-warning .cookie-consent-head .info {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}

#cookie-warning .cookie-consent-footer {
  display: flex;
  place-content: center;
  flex-direction: column;
}

#cookie-warning .button.button-blue {
  background-color: #0095d4;
  border-color: #0095d4;
  color: white;
}

#cookie-warning .button {
  margin: 10px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
  text-decoration: none;
  transition: background-color .25s ease 0s, color .25s ease 0s, border-color .25s ease 0s, opacity .25s ease 0s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 10px 15px;
  background: #0095d4;
  color: #333;
  border: 3px solid #0095d4;
}

#cookie-warning .button-secondary {
  background: white;
}

@media screen and (min-width: 768px) {
  #cookie-warning .cookie-consent-footer {
    flex-direction: row;
  }

  #cookie-warning .button {
    font-size: 17px;
    line-height: 17px;
    margin: 30px;
    height: 42px;
    padding: 0 55px;
  }
}

@media screen and (min-width: 1024px) {
  #cookie-warning .button {
    font-size: 18px;
    line-height: 18px;
    height: 46px;
    padding: 0 60px;
  }
}

@media screen and (min-width: 1280px) {
  #cookie-warning .button {
    font-size: 19px;
    line-height: 19px;
    height: 50px;
    padding: 0 65px;
  }
}

@media screen and (min-width: 1600px) {
  #cookie-warning .button {
    font-size: 20px;
    line-height: 20px;
    height: 50px;
    padding: 0 35px;
  }
}

</style>
